const applyCash = {
  queryList: [],
  urlMap: {
    select: {
      url: '/finance/payBillDetail/list'
      // ,
      // data: {
      //   sendType: '{default.sendType}'
      // }
    }
    // ,
    // update: '/school/schoolDegreeOffice/saveOrUpdate',
    // delete: '/school/schoolDegreeOffice/delete/{id}'
  },
  operList: [],
  titles: [
    {
      name: 'applyTime',
      label: '时间'
    },
    {
      name: 'systemSerialNum',
      label: '系统流水号'
    },
    {
      name: 'bankSerialNum',
      label: '银行流水号'
    },
    {
      name: 'operationType',
      label: '业务类型',
      map: {
        '6': '提现',
        '7': '管理费',
        '8': '专家费'
      }
    },
    {
      name: 'paperTitle',
      label: '论文题目'
    },
    {
      name: 'money',
      label: '金额'
    },
    {
      name: 'balanceNum',
      label: '余额'
    },
    {
      name: 'status',
      label: '状态'
    }
  ]
}
export default applyCash



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/fundsManage/applyCash.js